import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
  selector: 'app-care-service-details',
  templateUrl: './care-service-details.component.html',
  styleUrls: ['./care-service-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CareServiceDetailsComponent {
  name = input<string>(null);
  description = input<string>(null);
  price = input<number>(null);
  isFromPrice = input<boolean>(null);
  priceDescription = input<string>(null);
  discount = input<number>(null);

  constructor() {}
}
